export const environment = {
  production: true,
  buildId: '3100966967220511',
  configFile: 'config.json',
};
